define('MM/Models/ContentSearch/FacetMultipleChoiceValue',["jquery", "knockout", "score_bootstrap/Models/SitecoreId"], function ($, ko, SitecoreId) {
    "use strict";

    function FacetMultipleChoiceValue(id, value, text, scope, isPreselected, $dropDownButton) {
        this.scope = scope;
        this.id = SitecoreId.parse(id);
        this.value = value;
        this.text = text;
        this.selected = ko.observable(isPreselected);
        this.count = ko.observable(0);

        this.disabled = ko.computed(function () {
            // was found the only way how to trigger event to update UI regarding selected and enabled list options based on retrieved from server-side data.   
            $dropDownButton.triggerHandler("MultipleChoiceValue:disabled:checking");
            // facetContainer in "reset" method pass the count as a string, so we should make sure to convert it to a proper type
            return !this.selected() && (this.count()|0) === 0;
        }, this);

        this.resetCount = function () {
            this.count(0);
        };

        ko.applyBindings(this, this.scope);
    }

    return FacetMultipleChoiceValue;
});
